import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ListItem, ListItemType } from '../../../../../navigation/navigation.shared';

@Component({
    selector: 'list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    standalone: false
})
export class ListItemComponent {

    ListItemType = ListItemType;

    @Input()
    public onDragDrop$!: Subject<CdkDragDrop<Array<ListItem>>>;

    @Input()
    item!: ListItem;

    @Input()
    itemTitlesEditable!: boolean;

    @Input()
    itemDraggable = true;

}
